<template>
  <el-form class="demo-ruleForm" ref="lform" :model="form" :rules="rules" label-width="80px">
    <el-form-item label="账号" prop="account">
      <el-input v-model="form.account" placeholder="身份证号或护照号"></el-input>
    </el-form-item>
    <el-form-item label="姓名" prop="name">
      <el-input v-model="form.name" placeholder="请输入真实姓名"></el-input>
    </el-form-item>
    <el-form-item label="手机号" prop="mobile">
      <el-input type="number" v-model="form.mobile" placeholder="请输入手机号"></el-input>
    </el-form-item>
    <!--370827200004123012<el-form-item label="验证码" prop="sms_code">
      <el-input type="number" v-model="form.sms_code" placeholder="验证码">
        <el-button slot="suffix" :disabled="codeCd" type="primary" size="mini" @click="getcodeCd">
          <span v-if="!codeCd">发送验证码</span>
          <span v-else>{{ long }}s</span>
        </el-button>
      </el-input>
    </el-form-item>-->
    <el-form-item label="密码" prop="password">
      <el-input type="password" v-model="form.password" autocomplete="off" placeholder="请输入密码"></el-input>
    </el-form-item>
    <el-form-item label="确认密码" prop="password1">
      <el-input type="password" v-model="form.password1" autocomplete="off" placeholder="确认输入密码"></el-input>
    </el-form-item>
    <!--    <el-form-item label="验证码" prop="code">
          <el-input v-model="form.code" auto-complete="off" placeholder="验证码">
            <img slot="suffix" :src="codeUrl" class="login-code" @click="getCode"/>
          </el-input>
        </el-form-item>-->
    <el-form-item>
      <el-button
          :loading="loading"
          :disabled="loading"
          size="medium"
          type="danger"
          round
          @click="register"
          style="width:100%;background-color: #C32912;color: #fff">
        <span v-if="!loading">立即注册</span>
        <span v-else>注 册 中...</span>
      </el-button>
    </el-form-item>
    <div class="flex al-cn ju-cn">
      <el-checkbox v-model="checked">
        <div class="cl333 f12">我已阅读并同意</div>
      </el-checkbox>
      <div class="cl1189FB f12" @click="agreementClick">《用户注册协议》</div>
    </div>
  </el-form>
</template>
<script>
import {register} from "@/api/api";

export default {
  name: "Sign-in",
  props: {
    codeCd: {
      type: Boolean,
      default: false
    },
    long: {
      type: Number,
      default: 15
    },
    codeUrl: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      title: "用户登录",
      loading: false,
      form: {
        account: "", //账户
        mobile: "", //手机号
        name: "", //姓名
        sms_code: "",
        password: "", //密码
        password1: "", //确认密码
      },
      rules: {
        account: [
          {required: true, message: "请输入身份证号码或护照号", trigger: "blur"},
          {
            pattern: /(^[a-zA-Z0-9]{5,20}$)|(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            message: "请输入正确的证件号码",
            trigger: "blur"
          }
        ],
        mobile: [
          {required: true, message: "请输入手机号", trigger: "blur"},
          {
            pattern: /^1[3456789]\d{9}$/,
            message: "请输入正确的手机号",
            trigger: "blur"
          }
        ],
        sms_code: [{required: true, message: "请输入验证码", trigger: "blur"}],
        name: [{required: true, message: "请输入用户名", trigger: "blur"}],
        password: [{required: true, message: "请输入密码", trigger: "blur"},],
        password1: [
          {required: true, message: "请输入确认密码", trigger: "blur"},
          {
            validator: (rule, value, callback) => {
              if (value !== this.form.password) {
                callback(new Error("两次输入的密码不一致"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
      },
      checked: false,
    }
  },
  mounted() {

  },
  methods: {
    // 获取验证码
    getCode() {
      this.$emit('getCode');
    },
    // 协议
    agreementClick() {
      this.$emit('agreementClick')
    },
    // 获取手机验证码
    getcodeCd() {
      this.$emit('getcodeCd', this.form.mobile);
    },
    // 注册
    register() {
      if (!this.checked) {
        this.$message({
          message: "请先同意用户注册协议",
          type: "error"
        });
        return false;
      }
      this.$refs.lform.validate(valid => {
        if (valid) {
          this.loading = true;
          register(this.form).then(res => {
            this.loading = false;
            if (res.status === 200) {
              sessionStorage.setItem("token", res.data.token);
              this.$store.commit('setToken', res.data.token)
              this.resetForm('lform')
            }
          }).catch(e => {
            this.loading = false;
            console.log('请求错误', e)
            this.$message({
              message: "网络或程序异常！" + e,
              type: "error"
            });
          });
        } else {
          this.$message({
            message: "请输入合法的值",
            type: "error"
          });
          return false;
        }
      });
    },
    // 重置表单
    resetForm(formName) {
      this.$refs[formName].clearValidate(); //清除验证
      this.$refs[formName].resetFields(); //重置表单
    }
  }
}
</script>
<style scoped lang="scss">

</style>
